export default {
  "contact": "సంప్రదించండి",
  "us": "మమ్మల్ని",
  "contact_description": "మీకు ప్రశ్న, అభిప్రాయం లేదా వ్యక్తిగత జ్యోతిష్య సలహా కావాలా? మమ్మల్ని సంప్రదించండి – మేము 24–48 గంటల్లో స్పందిస్తాము.",

  "email": "ఇమెయిల్",
  "phone_whatsapp": "ఫోన్ / వాట్సాప్",
  "chat_on_whatsapp": "వాట్సాప్‌లో చాట్ చేయండి",
  "follow_us": "మమ్మల్ని అనుసరించండి",

  "full_name": "పూర్తి పేరు",
  "email_address": "ఇమెయిల్ చిరునామా",
  "phone_number": "ఫోన్ నంబర్",
  "subject": "విషయం",
  "message": "సందేశం",

  "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
  "email_placeholder": "you@email.com",
  "phone_placeholder": "ఐచ్చికం: +91 xxxxx-xxxxx",
  "subject_placeholder": "మేము మీకు ఎలా సహాయం చేయగలం?",
  "message_placeholder": "మీ జ్యోతిష్య అవసరాలపై మేము ఎలా సహాయం చేయాలో చెప్పండి...",

  "send_message": "సందేశం పంపండి",
  "message_sent_success": "సందేశం పంపబడింది! ✓",
  "thank_you_message": "మమ్మల్ని సంప్రదించినందుకు ధన్యవాదాలు! మేము 24–48 గంటల్లో స్పందిస్తాము."
};
